<template>
	<b-modal
		id="taskSortPopupModal"
		ref="taskSortPopupModal"
		title="Display Options"
		size="md"
		ok-title="Apply"
		ok-variant="success"
		cancel-title="Cancel"
		cancel-variant="warning"
		@ok="saveChange"
		@show="refreshData"
	>
		<div class="modal-body-lg">
			<b-row>
				<b-col>
					First
				</b-col>

				<b-col>
					<b-form-select
						v-model="taskOrder.first"
						:options="sortByOptions"
						value-field="item"
						text-field="name"
					/>
				</b-col>
				<b-col>
					<b-form-select
						v-model="taskOrder.firstDirection"
						:options="sortByDirections"
						value-field="item"
						text-field="name"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					Second
				</b-col>

				<b-col>
					<b-form-select
						v-model="taskOrder.second"
						:options="sortByOptions"
						value-field="item"
						text-field="name"
					/>
				</b-col>
				<b-col>
					<b-form-select
						v-model="taskOrder.secondDirection"
						:options="sortByDirections"
						value-field="item"
						text-field="name"
					/>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					Third
				</b-col>

				<b-col>
					<b-form-select
						v-model="taskOrder.third"
						:options="sortByOptions"
						value-field="item"
						text-field="name"
					/>
				</b-col>
				<b-col>
					<b-form-select
						v-model="taskOrder.thirdDirection"
						:options="sortByDirections"
						value-field="item"
						text-field="name"
					/>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<hr />
				</b-col>
			</b-row>
			<b-row style="text-align:right;">
				
			</b-row>
			<b-row style="text-align:left;">
				<b-col>
					<b-form-checkbox-compat
						id="checkbox-1"
						:model-value="taskOrder.hideChildren"
						@update:modelValue="taskOrder.hideChildren = $event"
						name="checkbox-1"
						switch
					>
						Hide Children
					</b-form-checkbox-compat>
				</b-col>
				<b-col>
					<b-form-checkbox-compat
						id="checkbox-2"
						:model-value="taskOrder.hideParents"
						@update:modelValue="taskOrder.hideParents = $event"
						name="checkbox-2"
						switch
					>
						Hide Parents
					</b-form-checkbox-compat>
				</b-col>
				<!--
					20231227 -- ZWS -- Bug with BOOTSTRAP-VUE vs. Vue 3 prevents checkboxes 
					working as they should.  I downgraded to an older version of Vue 3 to make it work.  
					A workaround available at https://github.com/bootstrap-vue/bootstrap-vue/issues/7182.
					The code is the workaround and it worked as of the date of this comment.  Note:
					There is necessary CSS included in this file.
				-->
				<!-- <b-col>
					<div class="custom-control custom-switch ml-2">
          				<input
            					class="custom-control-input"
							id="checkbox-2"
							v-model="taskOrder.hideParents"
							name="checkbox-2"
		  					type="checkbox"
            					value="true" />
							<label class="custom-control-label" for="checkbox-2">Hide Parents</label>
        				</div>					

				</b-col> -->
			</b-row>
			<b-row>
				<b-col>
					<hr />
				</b-col>
			</b-row>
			<b-row style="text-align:left;">
				<b-col>
					<b-form-checkbox-compat
						id="checkbox-3"
						:model-value="localExpandDetail"
						@update:modelValue="localExpandDetail = $event"
						name="checkbox-3"
						switch
					>
						Expand Detail
					</b-form-checkbox-compat>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<hr />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-checkbox
						id="checkbox-kanban"
						:model-value="displayKanban"
						@update:modelValue="displayKanban = $event"
						name="checkbox-kanban"
						:disabled="!isPremiumUser()"
						switch
					>
						Kanban

						<b-icon
							v-if="!isPremiumUser()"
							icon="question-circle"
							id="taskSortPopup-checkbox-kanban-question"/>

						<b-tooltip target="taskSortPopup-checkbox-kanban-question" triggers="hover">
							This is a premium feature.
						</b-tooltip>

					</b-form-checkbox>

					

				</b-col>
				<b-col>
					<b-form-select
						v-model="kanbanGroupName"
						:options="[
							{ name: 'Context', item: 'context' },
							{ name: 'Folder', item: 'folder' },
							{ name: 'Priority', item: 'priority' },
							{ name: 'Status', item: 'status' },
						]"
						value-field="item"
						text-field="name"
						:disabled="!displayKanban"
					/>
				</b-col>
			</b-row>
		</div>
	</b-modal>
</template>

<script>
import taskOps from '../mixins/taskOps'
import genericOps from '../mixins/genericOps'

export default {
	name: 'TaskSortPopup',
	mixins: [taskOps, genericOps],
	props: {
		expandDetail: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			localExpandDetail: null,
		}
	},
	computed: {
		displayKanban: {
			get: function() {
				return this.$store.getters.getUserPrefs.displayKanban
			},
			set: function(newValue) {
				// Directly set the value instead of toggling
				let userPrefs = this.$store.getters.getUserPrefs
				userPrefs.displayKanban = newValue
				this.$store.dispatch('setUserPrefs', userPrefs)
			},
		},
		kanbanGroupName: {
			get: function() {
				return this.$store.getters.getUserPrefs.kanbanGroup
			},
			set: function(newGroup) {
				
				let userPrefs = this.$store.getters.getUserPrefs
				userPrefs.kanbanGroup = newGroup
				this.$store.dispatch('setUserPrefs', userPrefs)
			},
		},
		
	},
	// 20260126 -- Copilot (Claude Sonnet 4.5) -- Sync localExpandDetail with prop
	// WHY: Checkbox must reflect current state when popup reopens
	mounted() {
		this.localExpandDetail = this.expandDetail
	},
	methods: {
		saveChange() {
			this.applySort(this.taskOrder)
			// 20260126 -- Copilot (Claude Sonnet 4.5) -- Emit expand detail change on save
			// WHY: Apply the checkbox state when user clicks OK
			console.log('TaskSortPopup saveChange - emitting localExpandDetail:', this.localExpandDetail)
			this.$emit('setDetail:TaskSortPopup', this.localExpandDetail)
		},
		refreshData() {
			this.taskOrder = this.$store.getters.getUserPrefs.taskSortOrder
		},
	},
}
</script>

<style scoped>
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 20px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
